import apis from '@/utils/apis';

export default {
  methods: {
    // 获取暂存url
    getStockReqUrl() {
      return apis.paymentProvisionalSave;
      // const billType = `${type}`;
      // let ret = '';
      // switch (billType) {
      //   case '13':
      //     ret = apis.billPaymentProvisionalSaveOverdue;
      //     break;
      //   case '20':
      //     ret = apis.refundRentSave;
      //     break;
      //   case '100':
      //     ret = apis.billPaymentProvisionalSaveStock;
      //     break;
      //   case '10':
      //     ret = apis.billPaymentProvisionalSave;
      //     break;
      //   case '11': // 押金暂存
      //     ret = apis.provisionalSave;
      // }
      // return ret;
    },
    // 获取提交url
    getSubmitReqUrl() {
      return apis.paymentRegister;
      // const billType = `${type}`;
      // let ret = '';
      // switch (billType) {
      //   case '13':
      //     ret = apis.billPaymentRegisterOverdue;
      //     break;
      //   case '20':
      //     ret = apis.refundRentSubmit;
      //     break;
      //   case '100':
      //     ret = apis.billPaymentRegisterStock;
      //     break;
      //   case '10':
      //     ret = apis.billPaymentRegisterTerm;
      //     break;
      //   case '11':
      //     ret = apis.depositRegisterSave;
      // }
      // return ret;
    }
  }
};
